import { isBrimley, isImpact, isEmea, isFlight } from './dcContext'

const FLIGHT_DC_PREFIX = '1081'
const IMPACT_DC_PREFIX = '1093'
const WR_DC_PREFIX = '1067'
const BRIMLEY_DC_PREFIX = '1042'

export const getDCPrefix = () => { return isFlight ? FLIGHT_DC_PREFIX : isBrimley ? BRIMLEY_DC_PREFIX : isEmea ? WR_DC_PREFIX : IMPACT_DC_PREFIX }
